import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=22d2bbea&scoped=true&"
import script from "./submitSuccess.vue?vue&type=script&lang=js&"
export * from "./submitSuccess.vue?vue&type=script&lang=js&"
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=22d2bbea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2bbea",
  null
  
)

export default component.exports